import styled from "styled-components/macro";

export const ImgTalkSigTextLogo = styled.img<{
  width: string;
  height: string;
}>`
  height: ${(props) => props.height};
  width: ${(props) => props.width};
`;
